import { useEffect } from 'react'

import UpgradeModal from '@/components/modal/UpgradeModal'

import { ref } from 'valtio'

import { useModal } from '@/features/modal-manager'

import { rundownPageStore } from '../rundown-page.store'

/**
 * Temporary hack that allows connecting to React context-based modal
 * to be used via valtio, outside of React.
 */
export function UpgradeModalAdapter() {
  const [upgradeModal, renderUpgradeModal] = useModal(UpgradeModal)

  useEffect(() => {
    // Expose context controls to valtio store
    rundownPageStore.modals.upgradeModal = ref(upgradeModal)
  }, [upgradeModal])

  return renderUpgradeModal({
    message:
      'This file exceeds the maximum of 5 MB available on the free plan.',
  })
}
